<template>
    <div class="input-group spinner">
        <div class="input-group-prepend">
            <button
              type="button"
              :disabled="errors.has('min')"
              :class="['btn btn-outline-medium-gray btn-outline-light', {'is-invalid': errors.has('min')}]"
              @click.prevent="decrease">
                <div class="icon icon-minus"></div>
            </button>
        </div>
        <input
            type="text"
            class="form-control"
            :value="numericValue"
            @change="update"
            ref="input"
        />
        <div class="input-group-append">
            <button
              type="button"
              :disabled="errors.has('max')"
              :class="['btn btn-outline-medium-gray btn-outline-light', {'is-invalid': errors.has('max')}]"
              @click.prevent="increase">
                <div class="icon icon-plus"></div>
            </button>
        </div>
        <div v-if="errors.any()" class="invalid-tooltip">
          {{ errors.get(error).replace(":step", step.toFixed(2)).replace(":unit", unit) }}
        </div>
    </div>
</template>

<script>
import Inputmask from 'inputmask/dist/inputmask/inputmask.numeric.extensions'
import Errors from '@Core/errors'

export default {

  name: 'Spinner',

  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      default: 0,
      type: Number
    },
    max: {
      default: 100,
      type: Number
    },
    step: {
      default: 1,
      type: Number
    },
    integerOnly: {
      default: false,
      type: Boolean
    },
    precision: {
      default: 1,
      type: Number
    },
    unit: {
      defaul: null,
      type: String
    },
    messages: {
      type: Object,
      default: () => {
        return {
          errors: {
            max: 'Za potražnju po većim količinama pošaljite nam poruku na etrgovina@svijetmetraze.hr.',
            min: 'Nižu vrijednost nije moguće naručiti.',
            wrongStep: 'Dopušteni korak je: :step :unit'
          }
        }
      }
    }
  },

  data: function () {
    return {
      numericValue: this.value,
      errors: new Errors(),
      error: null
    }
  },

  created() {
    if(this.max < this.value) {
      this.value = this.max
    }
    this.numericValue = this.value
  },

  computed: {
    onMin () {
      return this.numericValue === this.min
    },
    onMax () {
      return this.numericValue === this.max
    },
    nextStep () {
      return parseFloat((this.numericValue + this.step).toFixed(this.precision))
    },
    prevStep () {
      return parseFloat((this.numericValue - this.step).toFixed(this.precision))
    }
  },

  mounted () {
    Inputmask({
      alias: 'numeric',
      autoUnmask: true,
      radixPoint: ',',
      rightAlign: false,
      unmaskAsNumber: true,
      autoGroup: true,
      digits: this.precision,
      digitsOptional: this.precision === 0,
      suffix: ` ${this.unit}`,
      step: this.step,
      min: this.min,
      max: this.max
    }).mask(this.$refs.input)
  },

  methods: {

    increase () {
      this.error = this.onMax ? 'max' : null
      this.numericValue = this.nextStep
    },

    decrease () {
      this.error = this.onMin ? 'min' : null
      this.numericValue = this.prevStep
    },

    update ({ target }) {
      let value  = target.value

      this.numericValue = value

      this.error = (value * 1000) % (this.step * 1000) ? 'wrongStep' : (value > this.max ? 'max' : (value < this.min ? 'min' : null))
    }

  },

  watch: {

    numericValue: function (val, oldVal) {
      if (val <= this.min) {
        this.numericValue = this.integerOnly === true
          ? parseInt(this.min)
          : parseFloat(this.min)
      }

      if (val >= this.max) {
        this.numericValue = this.integerOnly === true
          ? parseInt(this.max)
          : parseFloat(this.max)
      }

      if ((val * 1000) % (this.step * 1000)) {
        this.numericValue = oldVal
      }

      if (val <= this.max && val >= this.min && !((val * 1000) % (this.step * 1000))) {
        this.$emit('input', val, oldVal)
      }
    },

    error: function (val, oldVal) {
      this.error && this.errors.record(this.error, this.messages.errors[this.error])
      this.error && setTimeout(() => {
        this.errors.clear()
        this.error = null
      }, 2500)
    }
  }
}
</script>

<style lang="scss" scoped>
  .invalid-tooltip {
    display: block;
    width: 100%;
    max-width: unset;
    right: 0;
  }
  button.is-invalid {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25)
  }
</style>
